module.exports = __webpack_public_path__ + "img/smartphone.e402d9a1.svg";